import React from "react";
import GetData from "./components/GetData";
import Header from "./components/Header";

function App() {
  return (
    <>
      <Header />
      <GetData />
    </>
  );
}

export default App;
